export default __webpack_public_path__ + "static/media/047-calligraphy.5cf91595.svg";